import {
  NetworkState,
  NetworkConnectionType,
  EffectiveConnectionType,
  NetworkInformation,
} from '../types/network';

/**
 * Gets the current network state from browser APIs.
 * Uses navigator.onLine and navigator.connection when available.
 * Safe to call in any browser - returns undefined values for unsupported APIs.
 *
 * @returns NetworkState object with current network information
 */
export function getNetworkState(): NetworkState {
  const now = Date.now();
  const online = navigator.onLine;

  // Check if navigator.connection is available (Chrome/Android)
  const { connection } = navigator as { connection?: NetworkInformation };

  if (!connection) {
    // Safari/Firefox fallback - only online status available
    return {
      online,
      lastUpdated: now,
    };
  }

  // Chrome/Android - rich network information available
  return {
    online,
    type: connection.type as NetworkConnectionType | undefined,
    effectiveType: connection.effectiveType as EffectiveConnectionType | undefined,
    downlink: connection.downlink,
    rtt: connection.rtt,
    lastUpdated: now,
  };
}
